import { render, staticRenderFns } from "./Await.vue?vue&type=template&id=489ddc44&scoped=true"
import script from "./Await.vue?vue&type=script&lang=js"
export * from "./Await.vue?vue&type=script&lang=js"
import style0 from "./Await.vue?vue&type=style&index=0&id=489ddc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ddc44",
  null
  
)

export default component.exports